import { z } from 'zod/mini';
import { OrderLineRuleSchema, OrderLineSchema } from '~/validation/api/packageSessionResponse';
import OptionRuleInterface from './optionRuleInterface';

/*
 * If the source options are not selected (quantity <= 0):
 * - Set the target quantity to 0
 * - Set the target visibility to false
 * Else
 * - Set the target visibility to true
 */
class Prerequisite implements OptionRuleInterface {
  // eslint-disable-next-line class-methods-use-this
  apply(
    orderLines: z.infer<typeof OrderLineSchema>[],
    sourceOrderLines: z.infer<typeof OrderLineSchema>[],
    targetOrderLines: z.infer<typeof OrderLineSchema>[],
    _rule: z.infer<typeof OrderLineRuleSchema>,
    pax: number,
  ) {
    return orderLines.map((orderLine) => {
      const orderLineClone = { ...orderLine };

      const actualSourceOrderLines = sourceOrderLines
        .find((sourceOrderLine) => sourceOrderLine.id === orderLine.id);

      if (!actualSourceOrderLines) {
        return orderLineClone;
      }

      const hasSelectedTargetOrderLine = targetOrderLines
        .some((targetOrderLine) => targetOrderLine.quantities.some((quantity) => quantity > 0));

      if (!hasSelectedTargetOrderLine) {
        orderLineClone.quantities = Array(pax).fill(0);
        orderLineClone.visible = false;
      } else {
        orderLineClone.visible = true;
      }

      return orderLineClone;
    });
  }
}

export default Prerequisite;
